import { z } from "zod";
import { ExternalMappingSchema } from "./externalMappings";

// Main Person entity. companyName and companySalesRepUserId are hydrated
// server-side from the person's company (null for company-less people).
export const PersonSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
  companyId: z.string().nullable(),
  companyName: z.string().nullable().optional(),
  companySalesRepUserId: z.string().nullable().optional(),
  isPrimaryCompanyContact: z.boolean(),
  organizationId: z.string(),
  externalMappings: z.array(ExternalMappingSchema).default([]),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Person = z.infer<typeof PersonSchema>;

// Create person request data
export const CreatePersonDataSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().optional(),
  companyId: z.string().nullable().optional(),
  isPrimaryCompanyContact: z.boolean().optional(),
});

export type CreatePersonData = z.infer<typeof CreatePersonDataSchema>;

// Update person request data
export const UpdatePersonDataSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  companyId: z.string().nullable().optional(),
  isPrimaryCompanyContact: z.boolean().optional(),
});

export type UpdatePersonData = z.infer<typeof UpdatePersonDataSchema>;

// Filter for searching people
export const PersonFilterSchema = z.object({
  search: z.string().optional(),
  companyId: z.string().optional(),
  limit: z.number().int().positive().optional(),
  offset: z.number().int().nonnegative().optional(),
});

export type PersonFilter = z.infer<typeof PersonFilterSchema>;

// API Response schemas
export const GetPeopleResponseSchema = z.object({
  people: z.array(PersonSchema),
  total: z.number(),
});

export type GetPeopleResponse = z.infer<typeof GetPeopleResponseSchema>;

export const GetPersonResponseSchema = z.object({
  person: PersonSchema,
});

export type GetPersonResponse = z.infer<typeof GetPersonResponseSchema>;

export const CreatePersonResponseSchema = z.object({
  person: PersonSchema,
});

export type CreatePersonResponse = z.infer<typeof CreatePersonResponseSchema>;

export const UpdatePersonResponseSchema = z.object({
  person: PersonSchema,
});

export type UpdatePersonResponse = z.infer<typeof UpdatePersonResponseSchema>;

export const DeletePersonResponseSchema = z.object({
  success: z.boolean(),
});

export type DeletePersonResponse = z.infer<typeof DeletePersonResponseSchema>;
